import App from "./App.svelte";
import checkEventData from "./js/checkEventData.js";

let resizeData = {};
let app;

function sendResizeMessage() {
  let documentHeight = document.querySelector("body").offsetHeight;
  window.parent.postMessage(
    { height: documentHeight, requestData: resizeData },
    "*"
  );

  console.log("sendResizeMessage:", {
    height: documentHeight,
    resizeData,
  });

  return null;
}

function handleMessage(event) {
  console.log("handleMessage");
  let goodEvent = checkEventData(event);
  if (goodEvent) {
    let { data } = event;
    resizeData = { ...data };
    sendResizeMessage();
  }

  return null;
}

function init() {
  app = new App({
    target: document.querySelector("#server-rendered-html"),
    props: {},
    hydrate: true,
  });

  app.$on("update", () => {
    sendResizeMessage();
  });
}

window.addEventListener("message", handleMessage);
document.addEventListener("DOMContentLoaded", init);

export default app;
